import { useTranslations } from "@zapier/i18n";
import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { Connection } from "@zapier/client";
import { getServiceIconUrl } from "@zapier/utils";
import styles from "./ConnectionPreviewCard.module.css";

interface Props {
  connection: Connection;
}

export function ConnectionPreviewCard({ connection }: Props) {
  const t = useTranslations("connections-replace-modal");
  const versionlessSelectedApi = connection?.selectedApi?.split("@")[0] ?? "";
  const serviceIconSource =
    connection?.implementation?.images?.url64X64 ??
    getServiceIconUrl(versionlessSelectedApi);
  const ownerEmail = connection?.owner?.email ?? "";

  return (
    <div className={styles.card}>
      <div className={styles.identity}>
        {/* eslint-disable-next-line next/no-img-element -- dynamic service icon URL from the app registry, not a Next.js-optimizable local asset */}
        <img alt="" className={styles.serviceIcon} src={serviceIconSource} />
        <div className={styles.text}>
          <span className={styles.title}>{connection?.title}</span>
          {ownerEmail && <span className={styles.email}>{ownerEmail}</span>}
        </div>
      </div>
      {connection?.isShared && (
        <Tooltip content={t("labels.shared-connection")} placement="bottom">
          <TooltipFocusableTrigger>
            <Icon
              aria-label={t("labels.shared-connection")}
              name="personGroup"
              size={16}
              color="GrayWarm6"
            />
          </TooltipFocusableTrigger>
        </Tooltip>
      )}
    </div>
  );
}
